import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';


import { Stack, Alert, Drawer, Snackbar, Typography, Button, Card, AppBar, Toolbar, IconButton } from '@mui/material';


import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

// components
import { MHidden } from '../../components/@material-extend';
import Notifications from '../../components/_dashboard/soundbox/SoundboxNotifications';
//
import AccountPopover from './AccountPopover';


import { ONGOING_VIDEO_CALL_DATA } from '../../URLConstants';
import { messageService } from '../../MessagingService';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 85;
const APPBAR_MOBILE = 60;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  // backgroundColor: alpha(theme.palette.background.default, 0.72),
  backgroundColor: "transparent",
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    // padding: theme.spacing(-1),
    marginLeft: theme.spacing(-1)
  }
}));

const useStyles = makeStyles({

  actionButtons: {
    backgroundColor: '#FFF',
    marginRight: '10px',
    minWidth: '81px',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    borderRadius: '10px',
    boxShadow: '0px 10px 19px 1px #EAEAFF',
    minHeight: '36px',
    color: '#171D40',
    '&:hover': {
      color: '#FFF',
    },
  }
});

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ onOpenSidebar }) {

  const [openDrawer, setOpenDrawer] = useState(false); // State to control the drawer

  const [showVideoCallCard, setShowVideoCallCard] = useState(false);
  const [selectProxgyProductType, setSelectProxgyProductType] = useState('audiocube')
  const location = useLocation();
  const navigate = useNavigate();
  const classes = useStyles();

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: "bottom",
    horizontal: "right",
    msg: "",
    variant: "filled",
    severity: "info"
  });

  const vertical = "bottom";
  const horizontal = "right";


  const [isSearchVisible, setIsSearchVisible] = useState(false);

  // Function to toggle the visibility of the Typography
  const toggleSearch = () => {
    setIsSearchVisible((prev) => !prev);
  };


  const handleSnackBarClose = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  }


  useEffect(() => {

    const subscription = messageService.onMessage().subscribe(message => {
      if (message) {
        const msgPayload = JSON.parse(message?.text)
        if (msgPayload?.event === 'ON_VIDEO_CALL_ALERT')
          videoCallSubscriptionAlerts(msgPayload)
      }
    });

    // return unsubscribe method to execute when component unmounts
    // return subscription.unsubscribe

  }, []);


  function videoCallSubscriptionAlerts(msgPayload) {
    setShowVideoCallCard(msgPayload?.msg?.videoCallOngoing);
  }


  function getBackOnTheCall() {
    console.log("ongoingcall", ONGOING_VIDEO_CALL_DATA)

    navigate("/dashboard/livestream", { state: { userData: ONGOING_VIDEO_CALL_DATA?.userData, videoCallId: ONGOING_VIDEO_CALL_DATA?.id, channelName: ONGOING_VIDEO_CALL_DATA?.userData?.device?.kvs?.channelName }, replace: true })
  }

  const handleProductChangeForDashboard = () => {
    setAlertMetas({ ...alertMetas, severity: 'info', snackBarOpened: true, msg: "This feature is coming soon !" });
    setTimeout(
      () =>
        setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: "" })
      ,
      4000
    );
  }

  return (
    <RootStyle>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>



        <Snackbar anchorOrigin={{ vertical, horizontal }} open={alertMetas?.snackBarOpened} onClose={handleSnackBarClose} autoHideDuration={6000} >
          <Alert variant={alertMetas?.variant} severity={alertMetas?.severity} >
            {alertMetas?.msg}
          </Alert>
        </Snackbar>



        {/* <Box sx={{ flexGrow: 1 }} /> */}
        <Stack direction="row"
          spacing={{xs:0.25, md:2}}
          sx={{ width: '100%' }}
          alignItems="center"
          justifyContent="space-between">

          { location?.pathname === '/dashboard/soundboxT' &&
            <Typography variant="h4" sx={{color:'black', fontFamily: 'Montserrat' }}>AudioCube</Typography>
          }

          { location?.pathname === '/dashboard/merchants' &&
                      <Typography variant="h5" sx={{color:'black', fontFamily: 'Montserrat' }}>Merchants</Typography>
            }

          { location?.pathname === '/dashboard/organizationusers' &&
                      <Typography variant="h5" sx={{color:'black', fontFamily: 'Montserrat' }}>Users</Typography>
            
            }

          { location?.pathname === '/dashboard/soundboxcontrolcenter' &&
            <Typography variant="h5" sx={{ color: 'black',fontFamily: 'Montserrat'  }}>
            <span style={{ whiteSpace: 'nowrap' }}>Control Center</span>
          </Typography>

          }

          { location?.pathname === '/dashboard/organizations' &&
                      <Typography variant="h5" sx={{color:'black', fontFamily: 'Montserrat' }}>Organizations</Typography>
            }  

            { location?.pathname === '/dashboard/soundboxdevicedetails' &&
              <Typography variant="h5" sx={{ color: 'black', fontFamily: 'Montserrat' }}>
            <span style={{ whiteSpace: 'nowrap' }}>Merchant Details</span>
              </Typography>  
            }         
       
        <MHidden width='smDown'>
          <Card
            sx={{
              width: '100%',
              maxWidth: '100%',
              height: "50px",
              textAlign: "center",
              mr: 4,
            }}
          >
            <Stack direction="row" sx={{ minHeight: "56px", pl: 2 }} spacing={2} alignItems="center" justifyContent="flex-start">
              <SearchSharpIcon />
              <Typography sx={{ textAlign: "center", color: "#535353", fontSize: "15px", lineHeight: "18px", fontWeight: 600, opacity: "0.6" }}>Search here...</Typography>
            </Stack>
          </Card>
          </MHidden>

          <Stack direction="row" alignItems="center" spacing={{ xs: 0.25, sm: 1.5 }}>
            {/* <LanguagePopover /> */}
            {/* <Searchbar /> */}
            {/* <NotificationsPopover /> */}
            <AccountPopover />
            <MHidden width='smDown'>
              <Button variant="contained" sx={{height:'50px'}} className={classes?.actionButtons} size='large' startIcon={<HelpOutlineOutlinedIcon />}>Help</Button>
            </MHidden>
            <MHidden width='smUp'>
              <Button variant="contained"  sx={{ height: '51px', width: '50px !important', minWidth: '50px !important', padding: '0 !important' }} className={classes?.actionButtons} size='large'>
              <HelpOutlineOutlinedIcon fontSize='large'/>
              </Button>
            </MHidden>
            <MHidden width='lgUp'>
              <Button variant="contained"  sx={{ height: '51px', width: '50px !important', minWidth: '50px !important', padding: '0 !important' }} className={classes?.actionButtons} size='large'            onClick={() => {
                setOpenDrawer(true);
              }} // Open the drawer on click
                >
              <NotificationsNoneOutlinedIcon fontSize='large'/>
              </Button>
            </MHidden>
            <Drawer
              anchor="bottom"
              open={openDrawer}
              onClose={() => setOpenDrawer(false)} // Close when clicking outside
              sx={{
                '& .MuiDrawer-paper': {
                  height: '50vh', // Adjust height as needed
                  borderTopLeftRadius: '16px',
                  borderTopRightRadius: '16px',
                },
              }}
            >
        <Notifications/>
      </Drawer>
          </Stack>
        </Stack>
      </ToolbarStyle>

      
    </RootStyle>
  );
}